import React from 'react';
import './ElementSelector.css'
import { isCurrentType } from './helpers/isCurrentType';
import TypeDropdownControl from './TypeDropdownControl/TypeDropdownControl';

const getClassTypeModifier = (isSelected) => (
    `element-type ${isSelected ? "element-type--active" : "element-type--inactive"}`
)

const TypeMapper = ({ elementTypes, prepareData, handleDragChange, attachStyleToSvg, currentType, onTypeSelect, isCheckEnabled, missingTypes,recommendedTypeChangeHandler,recommendedTypeCurrent, bodyListName, showFixedElements, toggleShowFixedElements, showSwitchButton, ...other }) => (
    elementTypes.map(type => {
        const isSelected = isCurrentType(type, currentType);

        return (
            <li
                key={type}
                className={getClassTypeModifier(isSelected)}
            >
                <TypeDropdownControl
                    isSelected={isSelected}
                    type={type}
                    isCheckEnabled={isCheckEnabled}
                    missingTypes={missingTypes}
                    bodyListName={bodyListName}
                />
            </li>
        )}
    )
);

const ElementSelector = (props) => (
    <ul className="element-selector">
        <TypeMapper {...props} />
    </ul>
)

export default ElementSelector;





// WEBPACK FOOTER //
// ./src/containers/Page/ElementSelector/ElementSelector.js